import React from 'react'
import s from './Tabs.module.scss'
import c from 'classnames'

interface Tab {
  content: React.ReactNode
  id: string
  label: string
}

interface TabsProps {
  activeTab: string
  onTabClick: (tabId: string) => void
  tabs: Tab[]
}

const Tabs: React.FC<TabsProps> = ({ activeTab, tabs, onTabClick }) => (
  <div className={s.container}>
    <div className={s.tabs}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={c(s.tab, activeTab === tab.id && s.activeTab)}
          onClick={() => {
            onTabClick(tab.id)
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
    <div>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={c(s.tabContent, activeTab === tab.id && s.activeContent)}
        >
          {tab.content}
        </div>
      ))}
    </div>
  </div>
)

export default Tabs
